import { useQuery } from '@tanstack/react-query'

import { useLegacyPublicApi } from '@/services/api/ApiContext'

import { SERVICE_BOOKING_FLEET_PATH } from '@/services'

export const useGetServiceBookingFleet = (appPath, config = {}) => {
  const api = useLegacyPublicApi()
  return useQuery({
    queryKey: ['get-service-booking-fleet', appPath],
    queryFn: async () => {
      if (!api || !appPath) {
        return false
      }
      const { data } = await api.get(
        SERVICE_BOOKING_FLEET_PATH.replace('{appPath}', appPath),
      )
      return data
    },
    ...config,
  })
}
